import CancelIcon from "@mui/icons-material/Cancel";
import { Button, useNotify, useRefresh, useRecordContext } from "react-admin";
import { dormitoryRequests } from "api/dormitoryApi";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";

const CancelDialog = ({ disabled = false }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const cancelOrder = async () => {
    await dataProvider.customRequest(dormitoryRequests.cancelAccommodationOrder(record.id), null, "PUT");
    notify("Настанителната заповед е отказана", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      onConfirm={cancelOrder}
      titleContent="Отказване на настанителна заповед"
      message="Сигурни ли сте, че искате да откажете настанителната заповед? Тя няма да може да се редактира."
      triggerButton={
        <Button
          startIcon={<CancelIcon />}
          label="Откажи"
          disabled={disabled}
        />
      }
    />
  );
};

export default CancelDialog;
